import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { VehicleVisualsService }           from './vehicle-visuals.service';
import { VehicleVisualsSettingsComponent } from './vehicle-visuals.settings.component';
import { VehicleVisualsSettingsModel }     from './typings/vehicle-visuals.settings';

export const VehicleVisualsStates : Array<NgHybridStateDeclaration> = [
  {
    component: VehicleVisualsSettingsComponent,
    name     : 'app.vehicle-visuals-settings',
    resolve  : [
      {
        deps     : [ VehicleVisualsService ],
        resolveFn: ( vehicleVisualsService : VehicleVisualsService ) : Promise<VehicleVisualsSettingsModel> => vehicleVisualsService.getSettings(),
        token    : 'settings'
      }
    ],
    url: '/vehicle_visuals_settings'
  }
];
